var React = require('react');

function Padlock (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"15","cy":"15","fill":"#c4bfb6","opacity":".2","r":"15","key":0}),React.createElement("path",{"d":"M19.5 11.333h-.75V9.81C18.75 7.707 17.07 6 15 6s-3.75 1.707-3.75 3.81v1.523h-.75c-.825 0-1.5.686-1.5 1.524v7.62C9 21.313 9.675 22 10.5 22h9c.825 0 1.5-.686 1.5-1.524v-7.619c0-.838-.675-1.524-1.5-1.524zm-2.175 0h-4.65V9.81c0-1.303 1.042-2.362 2.325-2.362s2.325 1.059 2.325 2.362z","fill":"#65686b","fillRule":"nonzero","key":1})]));
}

Padlock.defaultProps = {"height":"30","width":"30"};

module.exports = Padlock;

Padlock.default = Padlock;
